import Modal from './Modal';
import Button from './Button';

interface MessageModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  closeText?: string;
}

function MessageModal({
  isOpen,
  onClose,
  title,
  message,
  closeText = 'Fechar',
}: MessageModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <Button type="button" variant="secondary" onClick={onClose} fullWidth>
          {closeText}
        </Button>
      }
    >
      <p className="text-gray-600">{message}</p>
    </Modal>
  );
}

export default MessageModal;